<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    :class="{ active: isActive }"
   
  >
    <a
      v-if="isMenu"
      class="sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      :style="{color:this.$global.globalTextColor}"
      @click.prevent="collapseMenu"
    >
      <template v-if="addLink">
        <span class="sidebar-mini-icon">{{ linkPrefix }}</span>
        <span class="sidebar-normal" :style="{color:this.$global.globalTextColor}">
         {{ link.name }} <b class="caret"></b>
        </span>
      </template>
      <template v-else>
        <i :class="link.icon+ ' text-bar-color'" :style="{color:textColor}"></i>
      <p :style="{color:this.$global.globalTextColor}" class="text-bar-color">{{ link.name }} <b class="caret"></b></p>
      </template>
    </a>

    <collapse-transition>
      <div
        v-if="$slots.default || this.isMenu"
        v-show="!collapsed"
        class="collapse show"
      >
        <ul class="nav">
          <li>
     
          <slot></slot>
          </li>
        </ul>
      </div>
    </collapse-transition>

    <BetaBadge position="center" v-if="showBeta">
      <slot
        name="title"
        v-if="children.length === 0 && !$slots.default && link.path"
      >
        <component
          :to="link.path"
          @click.native="linkClick"
          :is="elementType(link, false)"
          :class="{ active: link.active }"
          :target="link.target"
          :href="link.path"
        >
          <template v-if="addLink">
            <span class="sidebar-mini-icon">{{ linkPrefix }}</span>
            <span class="sidebar-normal" :style="{color:this.$global.globalTextColor}">{{ link.name }}</span>
          </template>
          <template v-else>
            <i :class="link.icon + ' text-bar-color'" :style="{color:textColor}"></i>
            <p :style="{color:this.$global.globalTextColor}" class="text-bar-color">{{ link.name }}</p>
          </template>
        </component>
      </slot>
    </BetaBadge>

    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path && !showBeta"
    >
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        :class="{ active: link.active }"
        :target="link.target"
        :href="link.path"
      >
        <template v-if="addLink">
          <span class="sidebar-mini-icon">{{ linkPrefix }}</span>
          <span class="sidebar-normal" :style="{color:this.$global.globalTextColor}">{{ link.name }}</span>
        </template>
        <template v-else>
          <i :class="link.icon + ' text-bar-color'" :style="{color:textColor}"></i>
          <p :style="{color:this.$global.globalTextColor}" class="text-bar-color">{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BetaBadge } from '@/components';

export default {
  name: 'sidebar-item',
  components: {
    CollapseTransition,
    BetaBadge,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
      description:
        "Whether the item is a menu. Most of the item it's not used and should be used only if you want to override the default behavior."
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: '',
          path: '',
          children: []
        };
      },
      description:
        'Sidebar link. Can contain name, path, icon and other attributes. See examples for more info'
    },
    showBeta: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      children: [],
      collapsed: true
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    linkPrefix() {
      if (this.link.name) {
        let words = this.link.name.split(' ');
        return words.map(word => word.substring(0, 1)).join('');
      }
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find(c =>
          this.$route.path.startsWith(c.link.path)
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
    isMobile() {
      return window.innerWidth <= 768;
    },
    textColor(){
      return this.$global.globalTextColor
    },
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    linkClick() {

      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
      if(this.isMobile){
        this.$sidebar.toggleMinimize(false);
      }

    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    /*if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }*/
    this.collapseMenu();
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
};
</script>
<style>
.sidebar-menu-item {
  cursor: pointer;
}
.--sidebar-custom-item{
  margin: 10px 15px 0;
    border-radius: 30px;
    font-weight: 400;
    display: block;
    text-decoration: none;
    position: relative;
    text-transform: uppercase;
    cursor: pointer;
    font-size: 0.66759rem;
    padding: 10px 8px;
    line-height: 1.625rem;
}
.--sidebar-custom-item.--active p{
  font-weight: bold;
}
</style>
